import { createContext } from "react";
import type { WorkoutsContextType } from "./WorkoutsContext.types";

const WorkoutsContext = createContext<WorkoutsContextType | undefined>(undefined);
WorkoutsContext.displayName = "WorkoutsContext";

export default WorkoutsContext;
